import React from 'react';

import ReactLoadingOverlay from 'react-loading-overlay';

export function LoadingOverlay(props) {
  const { children, ...rest } = props;

  const options = {
    spinner: true,
    styles: {
      overlay: base => {
        return { ...base, background: 'rgba(69, 69, 69, 0.7)' };
      },
    },
    ...rest,
  };

  return (
    <ReactLoadingOverlay {...options}>
      {children}
    </ReactLoadingOverlay>
  );
}
